module.exports = {
  API_URL: "https://beta.gripinsights.com.au/api",
  AUTH0_DOMAIN: "auth.gripinsights.com.au",
  AUTH0_CLIENT_ID: "kAnDX9AEMvOitBek1P1l2OOeUDToPA0H",
  AUTH0_AUDIENCE: "https://api.grip.melbourne/api",
  MAP_URL: "https://beta.map.coreprojects.com.au",
};
